import React, {useContext, useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import AppRouter from "./components/AppRouter";
import NavBar from "./components/NavBar";
import {observer} from "mobx-react-lite";
import {Context} from "./index";
import {Spinner} from "react-bootstrap";
import './styles/global.css';
import './styles/Modal.css';
import { ToastProvider } from './contexts/ToastContext';
import { CartProvider } from './contexts/CartContext';
import './styles/Toast.css';
import CookieConsentBanner from './components/CookieConsentBanner';
import { check } from './http/userAPI';
import Footer from "./components/Footer";
import { fetchAndStoreCsrfToken } from './http/index';

const App = observer(() => {
    const {user} = useContext(Context)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        // Инициализируем CSRF токен при загрузке приложения
        fetchAndStoreCsrfToken();
        
        // Проверяем авторизацию пользователя
        check()
            .then(data => {
                if (data) {
                    user.setUser(data);
                    user.setIsAuth(true);
                }
            })
            .catch(error => {
                // Если ошибка 401 (неавторизован), просто очищаем токен
                if (error.response?.status === 401) {
                    localStorage.removeItem('token');
                    user.setUser({});
                    user.setIsAuth(false);
                }
                // Для других ошибок можно добавить логирование
                console.warn('Auth check failed:', error.message);
            })
            .finally(() => setLoading(false));
    }, [user])

    useEffect(() => {
        const observer = new MutationObserver(safeModalCleanup);
        observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
        return () => observer.disconnect();
    }, []);

    if (loading) {
        return (
            <div className="loading-container">
                <Spinner animation="grow" variant="primary" />
            </div>
        );
    }

    // --- Новый layout с условием ---
    const LocationWrapper = () => {
        const location = useLocation();
        const isFullScreenPage = location.pathname === '/' || location.pathname === '/shoes';
        if (isFullScreenPage) {
            return (
                <div className="app-flex-layout" style={{ minHeight: '100vh', height: '100vh', display: 'flex', flexDirection: 'column' }}>
                    <NavBar />
                    <main className="main-content-flex" style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                        <AppRouter />
                    </main>
                    <Footer />
                </div>
            );
        }
        return (
            <div className="app-flex-layout" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <NavBar />
                <main className="main-content-flex" style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                    <AppRouter />
                </main>
                <Footer />
            </div>
        );
    };

    return (
        <ToastProvider>
            <CartProvider>
                <LocationWrapper />
                <CookieConsentBanner />
            </CartProvider>
        </ToastProvider>
    );
});

function hardBodyUnlock() {
    document.body.className = '';
    document.body.removeAttribute('style');
    document.body.removeAttribute('data-rr-ui-modal-open');
    document.body.style.overflow = '';
    document.body.style.pointerEvents = '';
    document.body.style.paddingRight = '';
    document.documentElement.style.pointerEvents = '';
}

function safeModalCleanup() {
    const anyModalOpen = !!document.querySelector('.modal.show, .modal[style*="display: block"]');
    if (!anyModalOpen && (document.body.classList.contains('modal-open') || document.body.style.pointerEvents === 'none')) {
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.style.pointerEvents = '';
        document.documentElement.style.pointerEvents = '';
        document.querySelectorAll('.modal-backdrop, [data-rr-ui-backdrop], .modal-bg, .modal-overlay').forEach(el => {
            if (el.parentNode) el.parentNode.removeChild(el);
        });
        hardBodyUnlock();
    }
}

export default App;